import { render } from "./AssetsView.vue?vue&type=template&id=29257e04"
import script from "./AssetsView.vue?vue&type=script&lang=js"
export * from "./AssetsView.vue?vue&type=script&lang=js"

import exportComponent from "D:\\cwzl\\four-cw-net\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__